<template>
  <div class="error d-flex column bg-system-danger-cont">
    <div class="d-flex column gap-8">
      <div class="d-flex items-center header leaning-20">
        <slot name="header"></slot>
      </div>
      <div class="error-messages bg-cont-blur-50">
        <template v-if="items">
          <div v-for="error in items" :key="error">
            <div class="error-messages-item leaning-24 text-b14 d-flex items-center text-medium gap-16">
              {{ error }}
            </div>
            <div class="error-messages-divider bg-cont-muted-light w-100"></div>
          </div>
        </template>
        <template v-else>
          <div class="error-description leaning-24">
            <slot name="description"></slot>
          </div>
        </template>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue';
type ErrorBoxProps = {
  items?: string[];
};

defineProps<ErrorBoxProps>();

useSlots();
</script>

<style lang="scss" scoped>
@import url('./index.scss');
</style>
